import React from 'react';
import PropTypes from 'prop-types';

const ToastContent = ({ header, body }) => (
  <div>
    <strong style={{ fontSize: "16px" }}>{header}</strong>
    <p style={{ margin: "5px 0 0" }}>{body}</p>
  </div>
);

ToastContent.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired
};

export default ToastContent;

